import { makeAutoObservable, runInAction } from "mobx";
import homeService from "./homeService";
import { IBanner, StoreLocation, TBannerResponse } from "../../../types/common";
import http from "../../../libs/http";
import appStore from "../../../stores/appStore";
import { Product } from "../../../types/product";

/* eslint-disable @typescript-eslint/no-explicit-any */
class HomeStore {
  popularNow: Product[] = [];
  popularCategories: any[] = [];
  newProducts: Product[] = [];
  storeLocations: StoreLocation[] = [];
  banner?: IBanner = undefined;

  count: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  fetchPopularNow = async () => {
    const response = await homeService.fetchPopularNow(appStore.selectedCity || '');
    console.log(response);

    runInAction(() => {
      this.popularNow = response;
    });
  };

    fetchNewProducts = async () => {
    const response = await homeService.fetchNewProducts(appStore.selectedCity || '');
    console.log(response);

    runInAction(() => {
      this.newProducts = response;
    });
  };

  setCount = (count: number) => {
    runInAction(() => {
      this.count = count;
    });
  };

  fetchStoreLocation = async () => {
    const response = await homeService.fetchStoreLocation();

    runInAction(() => {
      this.storeLocations = response;
    });
  };

  async fetchBanner() {
    const { data } = await http.get<TBannerResponse>("/api/banner");
    if (data.success) {
      runInAction(() => {
        this.banner = data.banner;
      });
    }
  }
}

export default new HomeStore();
